export const styles = {
  normal: {
    color: "#0f1443",
    letterSpacing: 0.3,
    margin: 7,
    // textTransform:"capitalize"
  },
  black: {
    color: "#000000",
    letterSpacing: 0.3,
    margin: 7,
    // textTransform:"capitalize"
  },
};
